<script setup>
import { ref, watch } from 'vue'

const props = defineProps({
  src: { type: String, default: null },
  alt: { type: String, default: '' },
})
const failed = ref(false)
watch(() => props.src, () => { failed.value = false }, { flush: 'sync' })
</script>

<template>
  <div class="product-image-area">
    <img v-if="src && !failed" :key="src" :src="src" :alt="alt"
      class="product-image-area__img" @error="failed = true" />
    <span v-else class="product-image-area__fallback" role="img"
      :aria-label="alt ? `${alt}: изображение недоступно` : 'Изображение недоступно'">
      <i class="pi pi-image" aria-hidden="true"></i>
    </span>
  </div>
</template>

<style scoped>
.product-image-area {
  position: relative;
  width: 100%;
  aspect-ratio: var(--product-image-ratio, 1 / 1);
  box-sizing: border-box;
  padding: var(--product-image-padding, clamp(12px, 1.5vw, 20px));
  display: grid;
  place-items: center;
  grid-template-columns: minmax(0, 1fr);
  grid-template-rows: minmax(0, 1fr);
  min-width: 0;
  min-height: 0;
  background: var(--product-image-background, #fff);
}

.product-image-area__img {
  display: block;
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  min-width: 0;
  min-height: 0;
  object-fit: contain;
  object-position: center;
}

.product-image-area__fallback {
  display: grid;
  place-items: center;
  width: 100%;
  height: 100%;
  color: #aaa;
  font-size: 28px;
}
</style>
